import styled, { css } from 'styled-components';

import { AlertProps } from '../../ui';
import { rem } from '../../utils/index';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Medium)};
  width: 100%;
`;

export const StyledWrapper = styled.div<{
  align?: 'left' | 'right' | 'center';
}>`
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: ${({ theme }) => rem(theme.Spacing.Size.MediumLarge)};
  text-align: left;
  width: 100%;
`;

export const StyledAlertIcon = styled.div<{
  type: AlertProps['type'];
}>(({ theme, type }) => {
  switch (type) {
    case 'success':
      return css`
        fill: ${theme.Color.Feedback.Success};
      `;
    case 'error':
      return css`
        fill: ${theme.Color.Feedback.Alert};
      `;
    case 'warning':
      return css`
        fill: ${theme.Color.Feedback.Warning};
      `;
    case 'info':
      return css`
        fill: ${theme.Color.Feedback.Info};
      `;
  }
});

export const StyledTextContainer = styled.div<{
  align?: 'left' | 'right' | 'center';
}>`
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  text-align: left;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
`;

export const StyledButtonsWrapper = styled.div<{
  $align?: 'left' | 'right';
}>`
  display: flex;
  flex-direction: ${({ $align }) => ($align === 'left' ? 'row-reverse' : 'row')};

  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
`;

export const StyledCloseButtonWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  right: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  cursor: pointer;
`;
